import { ReactElement } from 'react';
import * as SC from './styles';

interface TabButtonProps {
  icon: ReactElement;
  label: string;
  value: string;
  isChecked: boolean;
  color?: string;
  handleCheck: CallbackFunction;
}

export default function TabButton(props: TabButtonProps) {
  const { icon, label, value, isChecked, color, handleCheck } = props;

  return (
    <SC.Container>
      <SC.ButtonContainer
        color={color}
        onClick={(e) => {
          handleCheck(value);
          e.stopPropagation();
        }}
      >
        <SC.StyledIconWrapper color={color}>{icon}</SC.StyledIconWrapper>
        {label}
      </SC.ButtonContainer>
      <SC.SelectionLineContainer>
        {isChecked && <SC.SelectionLine color={color} />}
      </SC.SelectionLineContainer>
    </SC.Container>
  );
}
